import React from 'react';
import PropTypes from 'prop-types';
import Snackbar from 'fuse-ui/components/Snackbar';

export const GeneralSuccessSnackbar = ( { additionalOptions, open, onClose } ) => {
    const defaultSnackbarProps = {
        autoHideDuration: 3000,
        message: 'Success.',
    };

    const snackbarProps = {
        ...defaultSnackbarProps,
        ...additionalOptions
    };

    return <Snackbar
        dataAutomationId="success-snackbar"
        open={open}
        onClose={onClose}
        {...snackbarProps}
    />;
};

GeneralSuccessSnackbar.propTypes = {
    additionalOptions: PropTypes.object,
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
};

export default GeneralSuccessSnackbar;
